import { GoogleMapContainedPopover } from '../google/GoogleMapContainedPopover'
import {
  GoogleListingHoverPopupContent,
  type GoogleListingHoverPopupListing,
} from './GoogleListingHoverPopup'

const DEFAULT_POPOVER_SIZE = { height: 160, width: 260 }

export function GoogleListingHoverPopover({
  listing,
  pixel,
}: {
  listing: GoogleListingHoverPopupListing
  pixel: { x: number; y: number }
}) {
  return (
    <GoogleMapContainedPopover
      className="pointer-events-none absolute z-[60]"
      defaultSize={DEFAULT_POPOVER_SIZE}
      pixel={pixel}>
      <GoogleListingHoverPopupContent listing={listing} />
    </GoogleMapContainedPopover>
  )
}
